import { Disclaimer, Video } from '../typing/main';

export const getDisclaimerKeys = (
  disclaimers: Disclaimer[],
  disclaimerService: (
    disclaimerText: string | undefined,
    scope?: string | undefined,
  ) => string | undefined,
) => {
  const galleryDisclaimers: Disclaimer[] = [];

  disclaimers.map((disclaimer: Disclaimer) => {
    const disclaimerKey = disclaimerService(
      disclaimer.description,
      'youtube-video-gallery',
    );
    const newDisclaimer = {
      token: disclaimer.token,
      number: disclaimerKey as string,
      description: disclaimer.description,
    };

    galleryDisclaimers.push(newDisclaimer);
  });

  return galleryDisclaimers;
};

export const handlePlaylistData = (
  playlistData: any,
) => {
  const procesedVideos: Video[] = [];

  playlistData.items.map((plVideo: any) => {

    const newVidep: Video= {
      videoId: plVideo.contentDetails.videoId,
      title: plVideo.snippet.title,
      body: plVideo.snippet.description,
      captionText: plVideo.snippet.title,
      altText: plVideo.snippet.title,
    };

    procesedVideos.push(newVidep);
  });

  return procesedVideos;
};
